/**
 * ScreenCheck Portal API
 * ScreenCheck Portal REST API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The RevokeReportShareTokenQuery model module.
 * @module model/RevokeReportShareTokenQuery
 * @version 0.0.1
 */
class RevokeReportShareTokenQuery {
    /**
     * Constructs a new <code>RevokeReportShareTokenQuery</code>.
     * @alias module:model/RevokeReportShareTokenQuery
     */
    constructor() { 
        
        RevokeReportShareTokenQuery.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>RevokeReportShareTokenQuery</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/RevokeReportShareTokenQuery} obj Optional instance to populate.
     * @return {module:model/RevokeReportShareTokenQuery} The populated <code>RevokeReportShareTokenQuery</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new RevokeReportShareTokenQuery();

            if (data.hasOwnProperty('report')) {
                obj['report'] = ApiClient.convertToType(data['report'], 'String');
            }
            if (data.hasOwnProperty('token')) {
                obj['token'] = ApiClient.convertToType(data['token'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>RevokeReportShareTokenQuery</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>RevokeReportShareTokenQuery</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['report'] && !(typeof data['report'] === 'string' || data['report'] instanceof String)) {
            throw new Error("Expected the field `report` to be a primitive type in the JSON string but got " + data['report']);
        }
        // ensure the json data is a string
        if (data['token'] && !(typeof data['token'] === 'string' || data['token'] instanceof String)) {
            throw new Error("Expected the field `token` to be a primitive type in the JSON string but got " + data['token']);
        }

        return true;
    }


}



/**
 * @member {String} report
 */
RevokeReportShareTokenQuery.prototype['report'] = undefined;

/**
 * @member {String} token
 */
RevokeReportShareTokenQuery.prototype['token'] = undefined;






export default RevokeReportShareTokenQuery;

